<template>
  <div style="margin-top: 20px;">
    <v-row>
      <span style="margin-left: 40px; margin-bottom: 10px;">Quantidade de usuários</span>
    </v-row>
    <v-row>
      <div style="margin-left: 40px;">
        <v-card elevation="1" style="width: 200px;">
          <v-list-item>
            <v-list-item-avatar tile>
              <v-icon x-large>android</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">Android</v-list-item-title>
              <v-list-item-subtitle>{{quantidadeAndroid}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
      <div style="margin-left: 20px;">
        <v-card elevation="1" style="width: 200px;">
          <v-list-item>
            <v-list-item-avatar tile>
              <v-icon x-large>mdi-apple</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">iOS</v-list-item-title>
              <v-list-item-subtitle>{{quantidadeIos}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
    </v-row>
    <v-row style="margin-top: 40px;">
      <span style="margin-left: 40px; margin-bottom: 10px;">Colunas Publicadas</span>
    </v-row>
    <v-row>
      <div v-for="(editorial, i) in editorialPublicado" :key="i" style="margin-left: 40px;">
        <v-card class="mx-auto" max-width="344">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">{{ editorial.titulo }}</v-list-item-title>
              <v-list-item-subtitle>{{ moment(editorial.data).format('dddd, DD/MM/YYYY') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-img
            class="white--text align-end"
            aspect-ratio="2"
            :src="editorial.publicacaoPrincipal[0].midia[0].imagem[0]"
          ></v-img>
          <v-card-text class="text--primary">
            <div>{{ editorial.descricao }}</div>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>

          <v-card-title>Interações</v-card-title>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>remove_red_eye</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="text-align: start;">Visualizações</v-list-item-title>
            <v-list-item-subtitle>{{editorial.quantidadeVisualizacao}}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>favorite</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="text-align: start;">Curtidas</v-list-item-title>
            <v-list-item-subtitle>{{editorial.quantidadeCurtidas}}</v-list-item-subtitle>
          </v-list-item>

          <v-divider></v-divider>
          <!--<v-card-actions>
            <v-btn color="red" text dark>Despublicar</v-btn>
          </v-card-actions>-->
        </v-card>
      </div>
    </v-row>
  </div>
</template>

<script>
import EditorialService from "../services/editorialServices";
import ClienteService from "../services/clienteService";
// import PublicacaService from "@/services/publicacaoService.js";
import moment from "moment";
export default {
  data() {
    return {
      editorialPublicado: [],
      quantidadeAndroid: 0,
      quantidadeIos: 0,
    };
  },
  beforeCreate() {},
  methods: {
    async carregarListaPublicado() {
      var resultPub = await EditorialService.listarEditorialPublicado();
      const lista = resultPub.data.data.listarEditorial;
      this.editorialPublicado = lista;
    },
    async carregarQuantidadeClinete() {
      var androidQuant = await ClienteService.quantidadeCliente("ANDROID");
      var iosQuant = await ClienteService.quantidadeCliente("IOS");

      this.quantidadeAndroid = androidQuant.data.data.quantidadeCliente;
      this.quantidadeIos = iosQuant.data.data.quantidadeCliente;
    },
  },
  created() {
    moment.locale("pt-BR");
    this.moment = moment;
    this.carregarListaPublicado();
    this.carregarQuantidadeClinete();
  },
};
</script>

<style>
</style>
